<!-- #region Customer -->

<section [ngClass]="lang" class="partiner-logos slider p-5">

  <div class="slide" *ngFor="let item of data">
    <img [src]="'./'+item.image" alt="Company Partiner" [title]="item.title.en" (load)="onLoading(item.title.en)">
    <div [id]="item.title.en" class="spinner-grow text-primary" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>

</section>

<img data-lazy="./assets/images/items/error.gif" />

<!-- #endregion -->
